import src from "IMAGE";
export default { src, width: 1710, height: 334, blurWidth: 0, blurHeight: 0};
